module.exports = __webpack_public_path__ + "media/images/categories/carousel/internet-and-technology-1f86612f4c5179d0b5a5741af8963427.jpg";